import type { RouteRecordRaw } from 'vue-router'
import component from './index.vue'

export const indexRoute: RouteRecordRaw = {
  path: '/',
  name: 'index',
  component,
}
